module.exports = [{"name":"USD","symbol":"$","label":"USD($)"},{"name":"INR","symbol":"₹","label":"INR(₹)"},{"name":"EUR","symbol":"€","label":"EUR(€)"},{"name":"GBP","symbol":"£","label":"GBP(£)"},{"name":"JPY","symbol":"¥","label":"JPY(¥)"},{"name":"MMK","symbol":"K","label":"MMK(K)"},{"name":"SGD","symbol":"S$","label":"SGD(S$)"},{"name":"NGN","symbol":"₦","label":"NGN(₦)"},{"name":"THB","symbol":"฿","label":"THB(฿)"}]


//////////////////
// WEBPACK FOOTER
// ./src/components/json/currency.json
// module id = PRc+
// module chunks = 74